import request from '@/utils/request_cn'
import util from "@/utils/util";

export function getEventList() {
  return request({
    url: '/sc-basic-merchant-backend/event/list',
    method: 'get',
  })
}

export function getSearchLog(data) {
  return request({
    url: '/sc-basic-merchant-backend/sha-sc-log/logsearch/sha-microservice-job-dispatcher',
    method: 'post',
    data: data,
  })
}

export function searchProduct(filters) {
  return request({
    url: '/sc-basic-merchant-backend/product/getProductOrderList' + util.map2QueryString(filters),
    method: 'get',
  })
}

export function searchProductCount(filters) {
    return request({
      url: '/sc-basic-merchant-backend/product/count' + util.map2QueryString(filters),
      method: 'get',
    })
  }

export function getSkuStockTrace(skuId, params) {
  return request({
    url: '/trace-service/stock/history/list/' + skuId + util.map2QueryString(params),
    method: 'post',
    data: params,
  })
}

export function getSkuNewStockTrace(skuId, params) {
  return request({
    url: '/sc-basic-merchant-backend/stock/history/new/list/' + skuId,
    method: 'post',
    data: params,
  })
}
export function getOrgData(requestId) {
  return request({
    url: '/sc-basic-merchant-backend/stock/history/detail/' + requestId ,
    method: 'get',
  })
}

export function queryVendor(needChildVendorFlag) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag,
    },
  })
}

export function manualForcePushOrder(orderLineNum) {
  return request({
    url: `/sc-basic-merchant-backend/manual/force/push/order/${orderLineNum}`,
  })
}

export function manualForcePushEmail(orderLineNum) {
  return request({
    url: `/sc-basic-merchant-backend/manual/force/push/email/${orderLineNum}`,
  })
}

export function deleteBpByVendorId(vendorId) {
  return request({
    url: `/sc-boutique-product-processing/exception/product/deleteBpByVendorId?vendorId=${vendorId}`,
    method: 'post',
  })
}

export function clearStockByVendorId(vendorId) {
  return request({
    url: `/sc-boutique-product-processing/exception/product/clearStockByVendorId?vendorId=${vendorId}`,
    method: 'post',
  })
}

export function deleteNotExistsSupplyPricePro(vendorId) {
  return request({
    url: `/sc-boutique-product-processing/exception/product/deleteNotExistsSupplyPricePro?vendorId=${vendorId}`,
    method: 'post',
  })
}

export function deleteNotExistsSkuPro(data) {
  return request({
    url: `/sc-boutique-product-processing/exception/product/deleteNotExistsSkuPro`,
    method: 'post',
    data,
  })
}

export function cleanVendorCountrySize(data) {
  return request({
    url: `/sc-boutique-product-processing/exception/product/clean/country/size`,
    method: 'post',
    data,
  })
}

export function getBoutiqueOrderPushList(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/list`,
    method: 'post',
    data,
  })
}

export function getDictList(data) {
  return request({
    url: `/sc-basic-merchant-backend/dict/manager/list`,
    method: 'post',
    data,
  })
}

export function addOrUpdateDict(data) {
  return request({
    url: `/sc-basic-merchant-backend/dict/manager/addOrUpdate`,
    method: 'post',
    data,
  })
}

export function delDict(params) {
  return request({
    url: `/sc-basic-merchant-backend/dict/manager/del`,
    params,
  })
}

export function getBoutiqueOrderPushLog(params) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/log`,
    params,
  })
}

export function pushBoutiqueOrder(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/batch/push`,
    method: 'post',
    data,
  })
}

export function getVendorConfig(params) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/vendor/config`,
    method: 'get',
    params,
  })
}

export function getVendorSystemList() {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/vendor/system/list`,
    method: 'get',
  })
}

// TODO 填写前缀
export function getIndexList(params) {
  return request({
    url: `/sc-basic-merchant-backend/order/index/name/list`,
    method: 'get',
    params,
  })
}

export function indexPushAll(params) {
  return request({
    url: `/sc-basic-merchant-backend/order/index/push/all`,
    method: 'get',
    params,
  })
}

export function indexPushIncremental(data) {
  return request({
    url: `/sc-basic-merchant-backend/order/index/push/incremental`,
    method: 'post',
    data,
  })
}

export function changeUseIndex(params) {
  return request({
    url: `/sc-basic-merchant-backend/order/index/bind/index`,
    method: 'get',
    params,
  })
}

export function delIndex(params) {
  return request({
    url: `/sc-basic-merchant-backend/order/index/del/index`,
    method: 'get',
    params,
  })
}

export function loadPushAllStatus(){
  return request({
    url: `/sc-basic-merchant-backend/order/index/get/result`,
    method: 'get'
  })
}

export function getBlackWhiteNameList(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteName/list`,
    method: 'get',
    params,
  })
}

export function addBlackWhiteNameList(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteName/add`,
    method: 'post',
    data,
  })
}

export function updateBlackWhiteNameList(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteName/update`,
    method: 'post',
    data,
  })
}

export function getBlackWhiteNameConfig(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteNameConfig/page`,
    method: 'get',
    params,
  })
}

export function addBlackWhiteNameConfig(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteNameConfig/batch/add`,
    method: 'post',
    data,
  })
}

export function updateBlackWhiteNameConfig(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteNameConfig/update`,
    method: 'post',
    data,
  })
}

export function deleteBlackWhiteNameConfig(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteNameConfig/delete`,
    method: 'post',
    data,
  })
}

export function getXXLJobList(data) {
  return request({
    url: `/sc-basic-merchant-backend/xxl/job/vendor/list`,
    method: 'post',
    data,
  })
}

export function triggerXXLJob(data) {
  return request({
    url: `/sc-basic-merchant-backend/xxl/job/trigger/job`,
    method: 'post',
    data,
  })
}

export function getVendorPromotionList(vendorId) {
  return request({
    url: `/basic-backend/promotion/discount/history/${vendorId}/promotion`,
    method: 'post',
  })
}

export function getVendorPromotionDiscountList(data) {
  return request({
    url: `/basic-backend/promotion/discount/history/list`,
    method: 'post',
    data,
  })
}

export function exportVendorPromotionDiscount(historyId) {
  return request({
    url: `/basic-backend/promotion/discount/history/export/${historyId}`,
    method: 'post',
  })
}

export function getTaskManageList(data) {
  return request({
    url: `/sc-basic-merchant-backend/task/manage/list`,
    method: 'post',
    data,
  })
}

export function pushBoutiqueOrderV2(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/v2/batch/push`,
    method: 'post',
    data,
  })
}
export function postVendorConfig(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/order/vendor/config`,
    method: 'post',
    data,
  })
}

export function blackWhiteNameExport(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteName/export`,
    method: 'post',
    data,
  })
}

export function pageVendorExtInfo(data){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/page`,
    method: 'post',
    data,
  })
}

export function vendorExtInfoDetail(id){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/detail?id=${id}`,
    method: 'get',
  })
}

export function updateVendorExtInfo(data){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/update`,
    method: 'post',
    data,
  })
}

export function delVendorExtInfo(id){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/del/ext/info?extInfoId=${id}`,
    method: 'get',
  })
}

export function saveVendorExtInfo(data){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/save`,
    method: 'post',
    data,
  })
}

export function getPdfFileContent(data){
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/config/get/pdf/content`,
    method: 'post',
    data,
  })
}

export function getComboVendorList(needChildVendorFlag) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag,
    },
  });
}

export function queryBlackWhiteName(params){
  return request({
    url: `/sc-basic-merchant-backend/vendor/blackWhiteName/detail`,
    method: 'get',
    params
  })
}

export function importPoizonSpuIdPool(data) {
  return request({
    url: `/sc-basic-merchant-backend/api/poizon-spu-id-pool/import`,
    method: "post",
    data,
  });
}
